import {Component, Input, OnInit} from '@angular/core';
import {Compbaser} from "../../../components/compbaser/compbases";
import {StoreSelectorsService} from "../../../services/store-selectors.service";
import {ILog} from "../../../interfaces";

@Component({
    selector: 'app-overview-log',
    templateUrl: './overview-log.component.html',
    styleUrls: ['./overview-log.component.scss'],
    standalone: false
})
export class OverviewLogComponent extends Compbaser implements OnInit {
    displayedColumns: string[] = ['date', 'message', 'severity'];
    dataSource: ILog[];

    @Input() enterpriseMode: boolean;


    constructor(private storeSelectorsService: StoreSelectorsService) {
        super();
        this.cod(
            this.storeSelectorsService.listenLogger().subscribe((logs: ILog[]) => {
                this.dataSource = [...logs].reverse();
            })
        );
    }

    ngOnInit() {
    }
}
